import { Component, OnInit,ViewChild } from '@angular/core';
import {  IonInfiniteScroll} from '@ionic/angular';
import { CommonService } from 'src/service/common.service';
import { WebParameterContext } from '../../../../model/common';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { NativeService } from 'src/service/native.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
declare var app;
@Component({
  selector: 'app-giftinventory-inventory-check',
  templateUrl: './giftinventory-inventory-check.component.html',
  styleUrls: ['./giftinventory-inventory-check.component.scss']
})
export class GiftinventoryInventoryCheckComponent implements OnInit {
  tabsIndex: number= 1;//tab切换类型
  searchValue:string = null;//查询内容
  timeShow:boolean = false;
  month: any = new Date();
  arrayData:Array<any>=[];
  erraMsg: any = null;
  uploadNum: any = [];
  PageNumber:number=0;
  productname:any= "库存数量";
  RecordCount: Number = 0;//列表总数量
  productShow:boolean = false; // 入库数量
  productShowstorge:boolean = false; // 盘库数量
  apiObj = {
    status: false,
    msg: ''
};//接口状态
loading: boolean = false;//加载效果
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  constructor(
    private http: HttpCustomerService,
    private router: Router,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private native:NativeService,
    public baseService: BaseCase,
    public base:BaseModal,
    public com: CommonService,
  ) { 
    this.month = this.com.getYearMonth;
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
    const that=this;
    that.LoadData(1);
   }
  // tab切换方法
  tabsEvent(num){
    const that =this;
    that.tabsIndex = num;
    if(num === 1){
      that.timeShow = false;
    }else{
      that.timeShow = true;
    }
    that.LoadData(1);
    switch (num) {
      case 1 :
        that.productname= "库存数量"
        break;

      case 2 :
        that.productname= "入库数量"
          break;

      case 3 :
        that.productname= "待审批数量"
          break;

      default:
        that.productname= "库存数量"
  }
    
  }
    /**
   * 返回这个月有多少天
   * @param data 当前日期
   */
  getCountDays(data){
    let curDate:any = new Date(data.replace("-","/"));
    /* 获取当前月份 */
        var curMonth = curDate.getMonth();
        curDate.setMonth(curMonth + 1);
        curDate.setDate(0);
        return curDate.getDate();
  }
  // 搜索条件
  serarEvent(e,type:string = 'type'){
    const that = this;
    that.LoadData(1);
   }
   // 入库
    // 下拉显示
  arrowSee(event, item,i) {
    const that = this;
     that.productShow = true;
  }
  // 下拉列表隐藏
  arrowhide(event, item) {
    const that = this;
    that.productShow = false;
  }
  // 盘库下拉上拉显示
  arrowSeestorge(event, item) {
    const that = this;
    item.Show = true;
    that.MarstDetailsList(item);
  }
  // 下拉列表隐藏
  arrowhidestorge(event, item) {
    const that = this;
     item.Show = false;
  }
 
    // 日期查询
  EventDateTimeClick(){
    console.log("测试1");
    let that = this;
    console.log(that.month);
    let _obj = {
      value:that.month,
      format:"yyyymm"
    };
    that.native.IosselectDateTime(_obj).then(data=>{
     that.month=that.formatDate(data.value);
     that.LoadData(1);
      console.log("测试");
    }).catch(eror=>{
    console.log(eror);
      });
  }
  // 日期查询转换方法
  // formatDate(date){
  //   if(date){
  //     let _date = new Date(date.replace(/-/g,"/"));
  //     let _y = _date.getFullYear();
  //     let _m = _date.getMonth()+1;
  //     let _d = _date.getDate();
  //     return _y + "-" + (_m < 10?"0"+_m:_m) + "-"+(_d < 10? "0"+_d:_d);
  //   }else{
  //     return date;
  //   }
  // }

  formatDate(date) {
    if (date) {
      let _y = date.split("-")[0];
      let _m = date.split("-")[1];
      // let _d = _date.getDate();
      // return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
      return _y + "/" + (_m < 10 ? "0" + _m : _m);
    } else {
      return date;
    }
  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.arrayData.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      that.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.arrayData = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName="QueryTBGiftMonthInventoryGift";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Content";
    body.Client.Name = "temp_content";
    body.Client.ClientType = 1;  
    let _dy:any={};    
    if(that.tabsIndex == 1){
      // _dy["Status"] = that.tabsIndex;
     }else{
       if(that.tabsIndex == 2){//入库记录
        body.ConfigName="GetProductPurchaseUnApprovalListGift";
      }else if(that.tabsIndex == 3){//产品盘库记录
        body.ConfigName="GetProductInventoryUnApprovalListGift";
      }
      _dy["beginDate"] = that.month.replace("/","-")+"-01 00:00:00";
      _dy["endDate"] =that.month.replace("/","-")+"-"+that.getCountDays(that.month+"-01")+" 23:59:59";
     }
    if(that.searchValue){
      if(that.tabsIndex == 1){
        _dy["GiftName"] = that.searchValue;
      }
      else{
        _dy["giftName"] = that.searchValue;
      }
    }
    body.RequestBody=JSON.stringify( _dy);
     
    that.http.post(app.DEFAULTURL, body).then(data => {
         /****判断是否第一页begin****/
         if(PageNumber == 1){
          that.arrayData = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }else{
          that.infiniteScroll.complete();
        }
        /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(items=>{
          items.Show=false;
          if(items.PurchaseDate){
            items.PurchaseDate=items.PurchaseDate.replace(/-/g,"/").replace("Z",'').replace("-00:00",'').replace("T","");
          }
          if(items.InventoryDate){
            items.InventoryDate=items.InventoryDate.replace(/-/g,"/").replace("Z",'').replace("-00:00",'').replace("T","");
          }
          that.arrayData.push(items);
        });
        // that.arrayData.forEach(item=>{
        //   item.ChineseName=that.com.FormatName(item.ChineseName||"");
        //   item.Mobile=that.com.PhoneNum(item.Mobile||"");
        // });
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.arrayData.length){
            that.infiniteScroll.disabled = true;
          }else{
            that.infiniteScroll.disabled = false;
          }
          /****上拉加载数据end****/
      }
 
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
  /**
   * 明细参数列表
   * @param items 主档参数列表
   */
   MarstDetailsList(items:any) {
    let that = this;
    items.errorMessage = "";
    const PageName = "ProductInventoryCheckList";
    let body = new WebParameterContext();
    body.ConfigName="GetProductPurchaseUnApprovalDetailsGift";
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = app.RowsPerPage;
    // body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Content";
    body.Client.Name = "temp_content";
    body.Client.ClientType = 1;
    let _dy={};
    if(that.tabsIndex == 2){
      _dy["approveNo"] = items.ApproveNo;
      body.ConfigName="GetProductPurchaseUnApprovalDetailsGift";
    }else if(that.tabsIndex == 3){
      body.ConfigName="GetProductInventoryUnApprovalDetailsGift";
      _dy["approveNo"] = items.ApproveNo;
      // body.RequestBody["state"]=items.State;
    }
    console.log(items,"grnn");
   
    items.DataList=[];
    // body.RequestBody="gmreemhrnm"
    // body.RequestBody=_dy;
    body.RequestBody=JSON.stringify( _dy);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        if(data.Status.Datas.length>0){
          data.Status.Datas.forEach(item=>{
            if(item.DamagedPictureUrl){
              item["imgUrlArr"]=[];
              // let obj={};
              item.DamagedPictureUrl= item.DamagedPictureUrl.split(",");
              console.log( item.DamagedPictureUrl);
              item.DamagedPictureUrl.forEach(element => {
                console.log(element)
                element =(app.FileUoloadUrl+element).replace(app.ImagePlaceholder,app.SmallImageType);
                // obj["url"] = element;
                item.imgUrlArr.push(element);
              });
             
            }
           
            items.DataList.push(item);
          });
          console.log(items.DataList)
        }else{
          items.errorMessage = "暂无数据";
        }
       
      }else{
        items.errorMessage = data.ResponseMessage.ErrorMessage;
      }
    }).catch(error => {
     console.log(error);
    });
  }
   /**
     * 
     * @param i 查看照片
     */
    imgPreview(item,items,i) {
      let that = this;
      let url = [];
      item.imgUrlArr.forEach(ite=>{
        let u = null;
        if(ite.indexOf("data:") > -1){
          u = ite
        }else{
          u = ite.trim().replace(app.SmallImageType,app.BigImageType);
        }
        url.push(u);
      })
      let ImgPreview = {
        imgUrl: url,
        index: i
      }
      that.com.setHistoryUrl(false);
      // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
      // that.router.navigate(["/tabs/contact/ImgPreview"]);
      that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{
        ImgPreview: JSON.stringify(ImgPreview)
      });
    }

}
